import know from "./knowledge.avif"
import "./About.css"

const About = ()=>
{
    return(
        <div className="about">
            <h1>About <span>Me</span></h1>
            <div className="aa">
                <div className="aboutone">
                    <p>1 . Strong foundation in Java and Data Structures & Algorithms</p>
                    <p>2 . Experienced in MERN Stack development (MongoDB, Express.js, React, Node.js)</p>
                    <p>3 . Solved 170+ problems on LeetCode, improving problem-solving and logical thinking skills</p>
                    <p>4 . Good understanding of frontend and backend integration</p>
                    <p>5 . Built both small and large-scale projects with real-world use cases</p>
                    <p>6 . Hands-on experience in writing clean, efficient, and maintainable code</p>
                    <p>7 . Strong analytical and debugging skills</p>
                </div>
                <div className="abouttwo">
                    <img src={know} alt="" />
                </div>     
            </div>   
        </div>
    )
}

export default About